import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../components/Sidebar";
import { get, post } from "../network/api";
import Modal from "../components/Modal";

const Orders = () => {
  const [selectedTab, setSelectedTab] = useState("All Orders");
  const [openDropdown, setOpenDropdown] = useState(null);

  const dropdownRefs = useRef([]);
  const [rating, setRating] = useState(1);
  const [comment, setComment] = useState("");
  const [selectedOrder, setOrder] = useState(null);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const toggleLoginModal = (order) => {
    setOrder(order);
    setLoginModalOpen(!isLoginModalOpen);
  };
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  let [orders, setOrders] = useState([]);
  let [allOrders, setAllOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    if (tab === "All Orders") {
      getOrders();
    }
    else if (tab === "Completed") {
      orders = allOrders.filter((order) => order.status === "delivered");
      setOrders(orders);
    }
    else if (tab === "Cancelled") {
      orders = allOrders.filter((order) => order.status ===
        "cancelled");
      setOrders(orders);
    }
    
  };


  const getStatusBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case "delivered":
        return "badge delivered";
      case "cancelled":
        return "badge cancelled";
      case "processing":
        return "badge processing";
      case "pending":
        return "badge pending";
      default:
        return "badge";
    }
  };

  // const handleDropdownToggle = (index) => {
  //   setOpenDropdown((prev) => (prev === index ? null : index));
  // };

  async function getOrders() {
    try {
      const data = await post("customer/get-orders");
      setOrders(data)
      setAllOrders(data);
      // setAddresses(data);
      setLoading(false);
    } catch (e) {
      console.log(e)
      setError(e.message); // Handle any errors
      setLoading(false);
    }
  }
  async function rateOrder(order){
    console.log(order)
    try {
      const data = await post(`customer/rate-order/${order._id}`,{
        userId:order.userId,
        restaurantId: order.restaurantId._id,
        overallRating:rating,
        comment:comment,
        items:[]
      });
    } catch (e) {
    }
  }
  useEffect(() => {
    getOrders();
  },[])
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openDropdown !== null &&
        dropdownRefs.current[openDropdown] &&
        !dropdownRefs.current[openDropdown].contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdown]);
  
  

  return (
    <React.Fragment>
      <section>
        <div className="wrapper">
          <div className="account_grid">
            <Sidebar />
            <div className="page-content order-page">
              <div className="order-header">
                <p className="page-content-title">Order History</p>
                {/* <div className="date-filter">
                  <label>Search By Date:</label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                  <span>To</span>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div> */}
              </div>

              <div className="tabs">
                <button
                  className={`tab-item ${
                    selectedTab === "All Orders" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("All Orders")}
                >
                  All Orders
                </button>
                {/* <button
                  className={`tab-item ${
                    selectedTab === "Summary" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("Summary")}
                >
                  Summary
                </button> */}
                <button
                  className={`tab-item ${
                    selectedTab === "Completed" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("Completed")}
                >
                  Completed
                </button>
                <button
                  className={`tab-item ${
                    selectedTab === "Cancelled" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("Cancelled")}
                >
                  Cancelled
                </button>
              </div>

              <div className="overflow_div">
                <table className="order-table">
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      {/* <th>Name</th> */}
                      <th>Restaurant Name</th>
                      <th>Amount</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((order, index) => (
                      <tr key={index}>
                        <td>{order.orderId}</td>
                        {/* <td>{order?.name}</td> */}
                        <td>{order.restaurantId?.restaurant_name}</td>
                        <td>€{order.totalAmount}</td>
                        <td className="text-center">
                          <span className={getStatusBadgeClass(order.status)}>
                            {order.status}
                          </span>
                        </td>
                        <td>
                          <div className="dropdown">
                            <button
                              className="dropdown-toggle"
                              onClick={() => toggleLoginModal(order)}
                              ref={(el) => (dropdownRefs.current[index] = el)}
                            >⋮
                            </button>
                            {openDropdown === index && (
                              <div className="dropdown-menu">
                                <button>View Detail</button>
                                <button>Share Restaurant</button>
                                <button>Give Feedback</button>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        show={isLoginModalOpen}
        onClose={() => setLoginModalOpen(false)}
        size={"md"}
      > 
           <div className="rating-container">
      <h3>Rate this Restaurant</h3>
      <div className="stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={star <= rating ? "filled-star" : "empty-star"}
            onClick={() => setRating(star)}
          >
            ★
          </span>
        ))}
      </div>
      <textarea
        placeholder="Write a comment..."
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
      <button onClick={()=>rateOrder(selectedOrder)}>Submit Rating</button>

      <style>
        {`
          .stars {
            font-size: 24px;
            cursor: pointer;
          }
          .filled-star {
            color: gold;
          }
          .empty-star {
            color: lightgray;
          }
          textarea {
            width: 100%;
            height: 50px;
            margin-top: 10px;
          }
          button {
            margin-top: 10px;
            padding: 8px 15px;
            background: #007bff;
            color: white;
            border: none;
            cursor: pointer;
          }
        `}
      </style>
    </div>

      </Modal>
    </React.Fragment>
  );
};

export default Orders;
